import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const NavNews = ({primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path fill="none" d="M11 13.01h3v6h-3z" />
        <path className={primaryClassName} d="M5 7.01v18h2v-16h18V15h2V7.01H5z" />
        <path className={primaryClassName} d="M17 11.01h6v2h-6zM17 15.01h6v2h-6zM17 19.01h6v2h-6zM16 11H9v10h7zm-2 8h-3v-6h3z" />
        <path className={tertiaryClassName} d="M9 23h5v2H9z" />
        <path className={secondaryClassName} d="M25 23H14v2h13V15h-2v8z" />
    </svg>
);

export default NavNews;
